import { render } from "./ExportForProcreate.vue?vue&type=template&id=a5e737f4"
import script from "./ExportForProcreate.vue?vue&type=script&lang=js"
export * from "./ExportForProcreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__